import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { CrmContext } from "../context";
import "./trade.css.scss";

export default function CrmTrade({ id, newTrade, ...data }) {
  const context = useContext(CrmContext);
  const history = useHistory();

  useEffect(() => {
    return () => (newTrade ? history.replace() : null);
  }, []);

  const setValor = () => {
    const str = data.valor_precatorio;

    if (str == null || str == "0") return "Valor não disponível";

    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(parseInt(str) / 100);
  };

  const setTribunalPrecatorio = () => {
    const nr = data.numero_precatorio;
    const jus = data.tribunal;

    if (nr == null || nr == undefined || nr == "") return jus;

    return `${jus || "Tribunal não informado"} - ${nr}`;
  };

  const setCredor = () => {
    const str = data.nome_credor;
    if (str == null || str == undefined || str == "")
      return "Credor não informado";
    return str;
  };

  return (
    <div
      className={`crm-trade-card${data.delayed ? " crm-trade-delayed" : ""}${
        newTrade ? " crm-trade-card-new" : ""
      }`}
      onClick={() => context.setTradeId(id)}
    >
      <div className="crm-trade-card-body">
        <span className="crm-trade-card-credor">{setCredor()}</span>

        <div className="crm-card-body-subtitles">
          <p>{setValor()}</p>
          <p>{setTribunalPrecatorio()}</p>
        </div>
      </div>
    </div>
  );
}
